import React from 'react'

import FormManager from "../../../common/form-manager"

import ButtonSubmitDeprecated from '../../../common/btn-submit/btn-submit'
import ButtonDeprecated from '../../../../gd-components/buttons/gd-button/gd-button'

type Props = {
    className?          : string
    style?              : any

    submitLabel?        : string
    submitBtnClass?     : string
    actionsClassName?   : string
    form                : FormManager

    showSubmit?         : boolean
    cancelButton?       : boolean
    onCancelClick?      : func

    children?           : any
}

// Deprecated

export default class FormAddDeprecated extends React.Component<Props> {
    static defaultProps = {
        submitLabel: 'Submit',
        showSubmit: true,
        cancelButton: false
    }

    render() {
        const buttonCancel = this.props.cancelButton ? <ButtonDeprecated type="normal"
                                                                         label="Cancel"
                                                                         onClick={this.props.onCancelClick}
                                                                         className="btn-cancel" /> : null;

        const submitClasses = Classes('submit',this.props.submitBtnClass);
        const mainClasses = Classes("gd-form-add",this.props.className);

        return (
            <div className={mainClasses} style={this.props.style}>
                {this.props.children}
                {this.props.showSubmit &&
                <div className={Classes("actions", this.props.actionsClassName)}>
                    <ButtonSubmitDeprecated form={this.props.form} label={this.props.submitLabel} className={submitClasses} /> {buttonCancel}
                </div>}
            </div>
        );
    }
}